import { render } from "./ModuleRestricted.vue?vue&type=template&id=6b58aba8"
import script from "./ModuleRestricted.vue?vue&type=script&lang=js"
export * from "./ModuleRestricted.vue?vue&type=script&lang=js"

import "./ModuleRestricted.vue?vue&type=style&index=0&id=6b58aba8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__